import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Page } from '../../models/static-page/page-model';
import { Observable } from 'rxjs/Observable';
import { Router } from "@angular/router";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class PageService {
  constructor(private http: Http, private readonly router: Router,
    private cookieService: CookieService) { }
  private serviceName = 'api/Page';
  getPages() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addPage(model: Page) {
    return this.http.post(`${this.serviceName}/CreatePage`, model, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  updatePage(model: Page) {
    return this.http.post(`${this.serviceName}/UpdatePage`, model, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  deletePage(id: string) {
    return this.http.get(`${this.serviceName}/DeletePage?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getPageById(pageId: string) {
    return this.http.get(`${this.serviceName}/GetPageById?id=` + pageId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  isUniqueUrl(url: string, id: number) {
    return this.http
      .get(`${this.serviceName}/IsUniqueUrl?url=` + url + '&Id=' + id, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/static-page/page.service.ts